import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AppSettings} from "../../config/config";
import {map} from 'rxjs/operators';

@Injectable()
export class StudentDeactivationService {

  private _url = AppSettings.API_ENDPOINT;

  constructor(private http: HttpClient) {
  }

  getDeactivateReasonList() {
    let  authToken = localStorage.getItem('usertoken');
    let headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', authToken);
    return this.http.get(this._url + '/studentlist/deactivation/reasons',{headers: headers})
      .pipe(map(res => res));
  }

  deactivateStudent(studentId,reasonId,academicId) {
    let  authToken = localStorage.getItem('usertoken');
    let data = {fkDeactivateReasonId:reasonId,studentId:studentId,academicId:academicId};
    let headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', authToken);
    return this.http.post(this._url + '/addstudent/deactivateStudent',data,{headers: headers})
      .pipe(map(res => res));
  }

}
